// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skl-ai-chat-settings {
  padding: 16px 0 20px;
}

.skl-copy {
  margin-bottom: 20px;
}

.skl-card {
  margin-bottom: 20px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #fff;
}

.skl-card__body {
  padding: 20px;
}

.skl-summary-row {
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr);
  gap: 16px;
  align-items: center;
  min-height: 44px;
  padding: 6px 0;
}

.skl-summary-row + .skl-summary-row {
  border-top: 1px solid #edf0f2;
}

.skl-form-group {
  margin-bottom: 20px;
}

.skl-actions-row {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}

.skl-actions-row--between {
  justify-content: space-between;
}

@media (max-width: 767.98px) {
  .skl-summary-row {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  .skl-actions-row,
  .skl-actions-row--between {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/ai-chat-settings/ai-chat-settings-skeleton/ai-chat-settings-skeleton.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,2CAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE;IACE,0BAAA;IACA,QAAA;EACF;EAEA;;IAEE,2BAAA;IACA,eAAA;EAAF;AACF","sourcesContent":[".skl-ai-chat-settings {\n  padding: 16px 0 20px;\n}\n\n.skl-copy {\n  margin-bottom: 20px;\n}\n\n.skl-card {\n  margin-bottom: 20px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background: #fff;\n}\n\n.skl-card__body {\n  padding: 20px;\n}\n\n.skl-summary-row {\n  display: grid;\n  grid-template-columns: 180px minmax(0, 1fr);\n  gap: 16px;\n  align-items: center;\n  min-height: 44px;\n  padding: 6px 0;\n}\n\n.skl-summary-row + .skl-summary-row {\n  border-top: 1px solid #edf0f2;\n}\n\n.skl-form-group {\n  margin-bottom: 20px;\n}\n\n.skl-actions-row {\n  display: flex;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n.skl-actions-row--between {\n  justify-content: space-between;\n}\n\n@media (max-width: 767.98px) {\n  .skl-summary-row {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n\n  .skl-actions-row,\n  .skl-actions-row--between {\n    justify-content: flex-start;\n    flex-wrap: wrap;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
